export const sidebarItems = [
  {
    path: "/dashboard/companies",
    icon: "mdi:company",
    name: "Companies",
  },
  {
    path: "/dashboard/admins",
    icon: "ri:admin-line",
    name: "All Admins",
  },
  {
    path: "/dashboard/createform",
    icon: "fluent:form-20-filled",
    name: "Create Form",
  },
];
